import { render } from "./AnnouncementBar.vue?vue&type=template&id=585d35be"
import script from "./AnnouncementBar.vue?vue&type=script&lang=js"
export * from "./AnnouncementBar.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__